import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { Tooltip } from "~/components/Tooltip";
import { AssetColumns, Token } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const TRANSFERABILITY_DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "transferability_description",
    label: "Transferability Description",
    tooltip: CatalogReferenceDataSlugs.transferability_description,
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        const value = item.isAsset
            ? (item.tokens?.find((token) => token.transferability_description)
                  ?.transferability_description ?? null)
            : (item as Token).transferability_description;

        if (!value) {
            return <Emdash />;
        }

        return (
            <Tooltip
                placement="top"
                tooltipContent={
                    <div className="px-3 py-2 text-sm max-w-sm whitespace-pre-line">
                        {value}
                    </div>
                }
            >
                {({ setTriggerRef }) => (
                    <span ref={setTriggerRef} className="line-clamp-2">
                        {value}
                    </span>
                )}
            </Tooltip>
        );
    },
};
